<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>

<div class="p-4 mb-4 mt-3 text-sm text-white bg-blue-500 rounded-lg" role="alert">
    To complete your booking, you will need to pay
    <span class="font-bold">${{paymentAmount}}</span>. You can pay with any major credit card or debit card.
</div>
<!--
<div class="p-4 mb-4 mt-3 text-sm text-blue-800 rounded-lg bg-primary-100 dark:bg-gray-800 dark:text-blue-400" role="alert">
    <span class="font-medium">Payment Note!</span> 
      <span class="text-gray-600 ">
        Please enter your card details below. A charge of 
        <span class="font-bold text-blue-600"> ${{this.paymentAmount}}</span> 
        will be applied to your card upon confirmation.
      </span>
  </div>
-->
<div class="flex flex-wrap lg:flex-nowrap w-full gap-4 p-page">

    <div class="bg-white rounded-md shadow w-full lg:w-1/2 p-3 card-left">
        <div class="flex flex-col">
            <div class="flex px-2 py-3 items-center">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:currency-dollar"
                    matTooltip="Name"></mat-icon>
                <div class="ml-3">
                    <div class="font-medium leading-6 text-primary">
                        Charge / Fee
                    </div>
                    <div class="mt-0.5 text-secondary">
                        ${{paymentAmount}}
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="p-4 mb-4 mt-3 text-sm text-gray-700 bg-gray-100 rounded-lg" role="alert">
                By entering your payment information and submitting your booking appointment, you agree to be charged
                the amount specified.
            </div>
        </div>
    </div>

    <div class="bg-white rounded-md shadow w-full lg:w-1/2 flex flex-col p-3 card-right">
        <div class="flex flex-row w-full items-center border-b mb-4">
            <mat-label class="font-semibold text-lg text-primary-500">
                Enter Payment Information
            </mat-label>
        </div>
        <form name="form" #addForm="ngForm"
            (keydown.enter)="$event.preventDefault()">
            <div class="pt-3">
                <div class="w-full flex flex-col vgs-form-field-container p-3">
                    <div class="flex flex-wrap w-full">
                        <div class="w-full lg:w-1/2 p-field">
                            <mat-label>Name on card</mat-label>
                            <div id="cc-name" matTooltip="Name on card" matTooltipPosition="above">
                                <div class="fake-input"></div>
                            </div>
                            <div *ngIf="addForm.submitted && vgsForm && vgsForm.state && vgsForm.state.cardholder_name && !vgsForm.state.cardholder_name.isValid"
                                class="invalid-vgs-field-feedback">
                                card holder name {{vgsForm?.state?.cardholder_name?.errorMessages[0]}}
                            </div>
                        </div>
                        <div class="w-full lg:w-1/2 p-field">
                            <mat-label>Card Number</mat-label>
                            <div id="cc-number" class="vgs-cardnumber" matTooltip="Card number"
                                matTooltipPosition="above">
                                <div class="fake-input"></div>
                            </div>
                            <div *ngIf="addForm.submitted && vgsForm && vgsForm.state && vgsForm.state.card_number && !vgsForm.state.card_number.isValid"
                                class="invalid-vgs-field-feedback">
                                card number {{vgsForm?.state?.card_number?.errorMessages[0]}}
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-wrap w-full">
                        <div class="w-full md:w-1/4 p-field">
                            <mat-label>CVV</mat-label>
                            <div id="cc-cvc" class="vgs-cardcvc" matTooltip="CVC" matTooltipPosition="above">
                                <div class="fake-input"></div>
                            </div>
                            <div *ngIf="addForm.submitted && vgsForm && vgsForm.state && vgsForm.state.cvv_code && !vgsForm.state.cvv_code.isValid"
                                class="invalid-vgs-field-feedback">
                                cvv {{vgsForm?.state?.cvv_code?.errorMessages[0]}}
                            </div>
                        </div>
                        <div class="w-full md:w-1/4 p-field">
                            <mat-label>Expiry Date</mat-label>
                            <div id="cc-expiration-date" matTooltip="Card expiry" matTooltipPosition="above">
                                <div class="block">
                                    <div class="fake-input"></div>
                                </div>
                            </div>
                            <div *ngIf="addForm.submitted && vgsForm && vgsForm.state && vgsForm.state.exp_date && !vgsForm.state.exp_date.isValid"
                                class="invalid-vgs-field-feedback">
                                Expiry {{vgsForm?.state?.exp_date?.errorMessages[0]}}
                            </div>
                        </div>
                        <div class="w-full md:w-1/3 p-field">
                            <mat-label>Billing Zip Code</mat-label>
                            <div id="cc-zip" matTooltip="Biling zipcode" matTooltipPosition="above">
                                <div class="block">
                                    <div class="fake-input"></div>
                                </div>
                            </div>
                            <div *ngIf="addForm.submitted && vgsForm && vgsForm.state && vgsForm.state.zip_code && !vgsForm.state.zip_code.isValid"
                                class="invalid-vgs-field-feedback">
                                Zip {{vgsForm?.state?.zip_code?.errorMessages[0]}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

    </div>
</div>